import type { Workspace } from '../types'

interface AgentSessionPaths {
    baseAgentPath: string
    transcriptsPath: string
    sessionFolderPath: string
    transcriptPath: string
    sessionId: string
}

export function getAgentSessionPaths(agentPath: string, sessionId: string): AgentSessionPaths {
    const isTranscriptFolder = agentPath.includes('.agent.json.transcripts/')
    const baseAgentPath = isTranscriptFolder ? agentPath.replace(/\.agent\.json\.transcripts\/.*$/, '.agent.json') : agentPath
    const normalizedSessionId = sessionId.trim()
    const transcriptsPath = `${baseAgentPath}.transcripts`
    const sessionFolderPath = isTranscriptFolder
        ? agentPath.replace(/\/?$/, '').replace(/\/transcript\.json$/, '')
        : `${transcriptsPath}/${normalizedSessionId}`

    return {
        baseAgentPath,
        transcriptsPath,
        sessionFolderPath,
        transcriptPath: `${sessionFolderPath}/transcript.json`,
        sessionId: normalizedSessionId,
    }
}

export function ensureAgentSessionDirectories(workspace: Workspace, agentPath: string, sessionId: string): AgentSessionPaths {
    const paths = getAgentSessionPaths(agentPath, sessionId)
    workspace.fs.mkdir(paths.transcriptsPath)
    workspace.fs.mkdir(paths.sessionFolderPath)
    return paths
}
